export default defineAppConfig({
  ui: {
    colors: {
      primary: 'orange',
      neutral: 'gray',
    },
    table: {
      slots: {
        tr: 'data-[selected=true]:bg-elevated/50 hover:bg-elevated/50 transition-colors cursor-pointer',
      },
    },
  },
})
